import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
	userLoginReducer,
	mfaSetupReducer,
	mfaVerifySetupReducer,
	mfaVerifyReducer,
	mfaStatusReducer,
	mfaRegenerateReducer,
} from './reducers/userReducers';
import { uiConfigReducer } from './reducers/configReducers';
import { reportStatusReducer } from './reducers/reportReducers';
import {
	attackHealthReducer,
	attackRecentAlertsReducer,
	attackEnrichReducer,
	attackMapTechniqueReducer,
	attackCoOccurrencesReducer,
	attackTechniquesReducer,
	attackDeciderUrlReducer
} from './reducers/attackReducer';

const reducer = combineReducers({
	userLogin: userLoginReducer,
	uiConfig: uiConfigReducer,
	reportStatus: reportStatusReducer,
	mfaSetup: mfaSetupReducer,
	mfaVerifySetup: mfaVerifySetupReducer,
	mfaVerify: mfaVerifyReducer,
	mfaStatus: mfaStatusReducer,
	mfaRegenerate: mfaRegenerateReducer,
	attackHealth: attackHealthReducer,
	attackRecentAlerts: attackRecentAlertsReducer,
	attackEnrich: attackEnrichReducer,
	attackMapTechnique: attackMapTechniqueReducer,
	attackCoOccurrences: attackCoOccurrencesReducer,
	attackTechniques: attackTechniquesReducer,
	attackDeciderUrl: attackDeciderUrlReducer,
});

const userInfoFromStorage = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null;
const refreshIntervalFromStorage = localStorage.getItem('refreshInterval') ? parseInt(localStorage.getItem('refreshInterval')) : 60000;

const initialState = {
	userLogin: { userInfo: userInfoFromStorage },
	uiConfig: { refreshInterval: refreshIntervalFromStorage }
};
const middleware = [ thunk ];

const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));

export default store;
